export function isSameEntity<T extends { id?: string | number | null; tempId?: string | number }>(
  first: T,
  second: T,
): boolean {
  const hasMatchByTempId = first.tempId && second.tempId && first.tempId === second.tempId;
  const hasMatchById = first.id && second.id && first.id === second.id;

  return Boolean(hasMatchByTempId || hasMatchById);
}

export function getEntityKey<T extends { id?: string | number; tempId?: string | number }>(entity: T): string {
  return String(entity.id ?? entity.tempId ?? "");
}
